import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { Col, Container, Label, Row,Form, Input, FormGroup, FormFeedback, Button, Spinner } from 'reactstrap'
import { error } from 'toastr';
import useGetPreSignedUrl from './useGetPreSignedUrl';
import axios from 'axios';
import useAddUsers from './useAddUsers';
import useEditUsers from './useEditUsers';

const ORG_ADMIN_ROLE_ID = '00000000-0000-0000-0000-000000000002';
const SUPER_SUER_ROLE = '00000000-0000-0000-0000-000000000006';
const SUPER_APPRAISER_ROLE = '00000000-0000-0000-0000-000000000007';

const AddEditForm = ({isEditMode,userData,onClose}) => {
    // hook for getting presigned url
    const{isGetting,isGot,getPreSignedUrl}= useGetPreSignedUrl();
    // hook for adding new users
    const{isPending,isSuccess,addUsers} = useAddUsers();
    // hook for editing users
    const{isEditing,isEdited,editUsers}=useEditUsers();
    // state for getting roles
    const[roles,setRoles]=useState([])
    // state for getting company
    const[companies,setCompanies]=useState([])
    // state for getting states
    const[states,setStates]=useState([])
    // logged in user role
    const[loggedRole, setLoggedRole] = useState('');
    // get org id
    const[orgId, setOrgId] = useState('');
    // state to hold the list of companies
    const [displayCompanies, setDisplayCompanies] = useState([]);
    // state to set the roles
    const[displayRole,setDisplayRole] = useState([]);

    // getting data from local storage
    useEffect(()=>{
        const cachedData = localStorage.getItem('appInitData')
        const roleData = JSON.parse(localStorage.getItem('userData'))
        if(roleData){
            const role = roleData.user.role;
            const org = roleData.user.org_id;

            setLoggedRole(role);
            setOrgId(org);
        }

        if (cachedData){
            const parsedData = JSON.parse(cachedData);
            setRoles(parsedData.role || [])
            setCompanies(parsedData.organization || [])
            setStates(parsedData.us_state || [])
        }
        
    },[])

     // This effect runs whenever the user's role, their org, or the master company list changes.
    useEffect(() => {
        console.log("logged in user role",loggedRole)
        console.log("Logged Role:", loggedRole);
        console.log("Org ID:", orgId);
        console.log("Companies:", companies);
        const SPECIFIC_ROLE_ID = '00000000-0000-0000-0000-000000000002'; 

        if (loggedRole === SPECIFIC_ROLE_ID && orgId && companies.length > 0) {
            // Case 1: The user has the specific role. Find their single company.
            const userCompany = companies.find(comp => comp.org_id === orgId);
            
            // Set the display list to be an array with just that one company, if found.
            setDisplayCompanies(userCompany ? [userCompany] : []);

        } else {
            // Case 2: The user has any other role. Show all companies.
            setDisplayCompanies(companies);
        }

    }, [loggedRole, orgId, companies])

    // use effect to set role when logged in is org admn
    useEffect(() => {
        const excludedRoles = [SUPER_SUER_ROLE, SUPER_APPRAISER_ROLE];

        // Check if the logged-in user is an Org Admin
        if (loggedRole === ORG_ADMIN_ROLE_ID) {
            const filteredRoles = roles.filter(
                role => !excludedRoles.includes(role.role_id)
            );
            setDisplayRole(filteredRoles);
        } else {
            setDisplayRole(roles);
        }

    }, [loggedRole, roles]);

    // hook form
    const{register,handleSubmit,formState:{errors},reset,watch}=useForm({
        defaultValues:{
            firstname:"",
            lastname:"",
            email:"",
            password:"",
            role:"",
            appraisersignature:"",
            appraisercertificate:"",
            company:"",
            phonenumber:"",
            license:"",
            state:"",
            expirationdate:"",
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    // getting role id
    const roleId = watch("role")
    console.log(watch("role"))

    // when editing,populate from the existing data
    useEffect(()=>{
        if(isEditMode && userData){
             console.log("User data for editing:", userData);
            const formValues = {
                firstname: userData.first_name,
                lastname: userData.last_name,
                email: userData.email_id,
                password: "", // Never pre-fill the password
                role: userData.role,
                company: userData.org_id,
                phonenumber: userData.phone_number, // Assuming the API key is phone_number
                license: userData?.appraiser?.license, // Assuming API key
                state: userData.state, // Assuming API key
                expirationdate: userData?.appraiser?.expiry_date ? new Date(userData?.appraiser?.expiry_date).toISOString().split('T')[0] : "", // Format date for input
                
                // We do not set values for file inputs
                appraisersignature: "",
                appraisercertificate: ""
            };
            reset(formValues) //setting the form values
        }
        else{
            reset(); //resetting the form values
        }
    },[isEditMode, userData, reset, displayCompanies, displayRole, states])

    // const onSubmit= async (data)=>{
    //     const payload = {
    //         first_name: data.firstname,
    //         last_name: data.lastname,
    //         email_id: data.email,
    //         // Only include password if a new one was typed
    //         ...(data.password && { password: data.password }),
    //         role: data.role,
    //         org: data.company,
    //         phone_number: data.phonenumber, // Assuming API key
    //         state: data.state, // Assuming API key
            
    //         // Add user_id for the edit mutation
    //         ...(isEditMode && { user_id: userData.user_id }) // 
    //     };

    //     // handle the upload if the role is appraiser
    //     if(data.role === "00000000-0000-0000-0000-000000000004"){
            
    //         payload.license = data.license;
    //         payload.expiry_date = data.expirationdate;

    //         // upload signature
    //         if(data.appraisersignature && data.appraisersignature.length >0){
    //             const signatureFile = data.appraisersignature[0];

    //              const signatureUrlRes = await getPreSignedUrl({email: data.email, file_name: signatureFile.name, content_type: signatureFile.type});
    //                     await fetch(signatureUrlRes.upload_url, {
    //                         method: 'PUT',
    //                         headers: {
    //                             'Content-Type': signatureFile.type,
    //                         },
    //                         body: signatureFile
    //         });

    //         // add signature view url to add user data
    //         payload.appraiser_sign_path  = signatureUrlRes.view_url

    //         }
           
    //         // upload certificate
    //         if (data.appraisercertificate && data.appraisercertificate.length > 0){
    //             const certficateFile = data.appraisercertificate[0];
    //             const certificateUrlRes = await getPreSignedUrl({email:data.email, file_name: certficateFile.name, content_type: certficateFile.type});
    //                 await fetch(certificateUrlRes.upload_url, {
    //                     method: 'PUT',
    //                     headers: {
    //                         'Content-Type': certficateFile.type,
    //                     },
    //                     body: certficateFile
    //         });


    //         // adddding certificate view url to add user data
    //         payload.appraiser_cert_path = certificateUrlRes.view_url
    //         }
            
    //     }

    //     if(isEditMode){
    //         console.log("EDiting done", payload)
    //         editUsers(payload,{
    //             onSuccess:()=>{
    //                 onClose();
    //             }
    //         })
    //     }
    //     else{
    //         console.log("adding done",payload)
    //         addUsers(payload,{
    //             onSuccess:()=>{
    //                 onClose();
    //             }
    //         });
    //     }

    //     // onClose();
    // }
    
    const APPRAISER_ROLES = [
        "00000000-0000-0000-0000-000000000004",
        "00000000-0000-0000-0000-000000000007",
    ];

    const onSubmit = async (data) => {
        const payload = {
            first_name: data.firstname,
            last_name: data.lastname,
            email_id: data.email,
            ...(data.password && { password: data.password }),
            role: data.role,
            org: data.company,
            phone_number: data.phonenumber,
            state: data.state,
            ...(isEditMode && { user_id: userData.user_id }),
        };

        if (APPRAISER_ROLES.includes(data.role)) {

            const appraiser = {
                license: data.license,
                expiry_date: data.expirationdate,
            };

            // Upload signature
            if (data.appraisersignature?.length > 0) {
                const signatureFile = data.appraisersignature[0];

                const signatureUrlRes = await getPreSignedUrl({
                    email: data.email,
                    file_name: signatureFile.name,
                    content_type: signatureFile.type,
                });

                await fetch(signatureUrlRes.upload_url, {
                    method: "PUT",
                    headers: {
                        "Content-Type": signatureFile.type,
                    },
                    body: signatureFile,
                });

                appraiser.appraiser_sign_path = signatureUrlRes.view_url;
            }

            // Upload certificate
            if (data.appraisercertificate?.length > 0) {
                const certificateFile = data.appraisercertificate[0];

                const certificateUrlRes = await getPreSignedUrl({
                    email: data.email,
                    file_name: certificateFile.name,
                    content_type: certificateFile.type,
                });

                await fetch(certificateUrlRes.upload_url, {
                    method: "PUT",
                    headers: {
                        "Content-Type": certificateFile.type,
                    },
                    body: certificateFile,
                });

                appraiser.appraiser_cert_path = certificateUrlRes.view_url;
            }

            payload.appraiser = appraiser;
        }

        if (isEditMode) {
            editUsers(payload, {
                onSuccess: () => {
                    onClose();
                },
            });
        } else {
            addUsers(payload, {
                onSuccess: () => {
                    onClose();
                },
            });
        }
    };

  return (
    <Container fluid>
        <Row>
            <Col>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='firstname' className='form-label'>First Name</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='firstname'
                                    name='firstname'
                                    placeholder='First Name'
                                    {...register("firstname",{required:"First Name required",
                                        minLength:{value:4,message:"First Name must have atleast 4 characters"},
                                        pattern:{value: /^[A-Za-z]+$/ ,message:"First Name must contain only letters (A–Z or a–z) with no spaces, numbers, or special characters."}
                                    })}
                                />
                                {errors.firstname && <span className="text-danger">{errors.firstname.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='lastname' className='form-label'>Last Name</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='lastname'
                                    name='lastname'
                                    placeholder='Last Name'
                                    {...register("lastname",{required:"Last Name required",
                                        minLength:{value:1,message:"Last Name must have atleast 1 characters"},
                                        pattern:{value: /^[A-Za-z]+$/ ,message:"Last Name must contain only letters (A–Z or a–z) with no spaces, numbers, or special characters."}
                                    })}
                                />
                                {errors.lastname && <span className="text-danger">{errors.lastname.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='email' className='form-label'>Email</Label>
                                <input
                                    type='email'
                                    className='form-control border-primary-subtle'
                                    id='email'
                                    name='email'
                                    placeholder='Email'
                                    {...register("email",{required:"Email required",
                                        setValueAs:(value)=>value?.trim().toLowerCase(),
                                        minLength:{value:6, message:"Email must have atleast 6 characters"},
                                        pattern:{value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message:"Invalid email format"}
                                    })}
                                />
                                {errors.email && <span className="text-danger">{errors.email.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='password' className='form-label'>Password</Label>
                                <input
                                    type='password'
                                    className='form-control border-primary-subtle'
                                    id='password'
                                    name='password'
                                    placeholder='Password'
                                    {...register("password",{required: isEditMode ? false : "Password required",
                                        minLength:{value:6,message:"Password must be at least 6 characters long"},
                                        maxLength:{value:12, message:"Password must not exceed 12 characters"},
                                        pattern:{value:/^(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{6,12}$/,
                                            message:"Password must be 6–12 characters long, include at least one uppercase letter, one lowercase letter, one number, one special character, and contain no spaces."}
                                    })}
                                />
                                {errors.password && <span className="text-danger">{errors.password.message}</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                                    
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='company' className='form-label'>Organization</Label>
                                <select
                                    className='form-select border-primary-subtle'
                                    id='company'
                                    name='company'
                                    defaultValue=""
                                    {...register("company",{required:"Company is required"})}
                                >
                                    <option value="" disabled>Select Organization</option>
                                    {displayCompanies.map((comp,index)=>(
                                        <option key={index} value={comp.org_id}>{comp.name}</option>
                                    ))}
                                </select>

                                {errors.company && <span className="text-danger">{errors.company.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='phonenumber' className='form-label'>Phone Number</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='phonenumber'
                                    name='phonenumber'
                                    placeholder='Phone Number'
                                    {...register("phonenumber",{pattern:{value:/^\+?[1-9][0-9]{7,14}$/, message: "Valid phone number required"},
                                        minLength:{value: 7, message:"Phone number must be atleast 8 digits long"},
                                        maxLength:{value: 15, message: "Phone number cannot exceed 15 digits"}
                                    })}
                                />
                                {errors.phonenumber && <span className="text-danger">{errors.phonenumber.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='state' className='form-label'>State</Label>
                                <select
                                    className='form-select border-primary-subtle'
                                    id='state'
                                    name='state'
                                    defaultValue=""
                                    {...register("state",{required:"State is required"})}
                                >
                                <option value="" disabled>Select State</option>
                                {states.map((state,index)=>(
                                    <option key={index} value={state.id}>{state.state_code}</option>
                                ))}
                                </select>

                                {errors.state && <span className="text-danger">{errors.state.message}</span>}

                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='role' className='form-label'>Role</Label>
                                <select
                                    className='form-select border-primary-subtle'
                                    id='role'
                                    name='role'
                                    defaultValue=""
                                    {...register("role",{required:"Role is required"})}
                                >
                                    <option value="" disabled>Select the Role</option>
                                    {displayRole.map((role,index)=>(
                                        <option key={index} value={role.role_id}>{role.display_name}</option>
                                    ))}
                                </select>
                                {errors.role && <span className="text-danger">{errors.role.message}</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                    
                    {/*Appraiser inputs here  */}
                    {(roleId === "00000000-0000-0000-0000-000000000004" || roleId === "00000000-0000-0000-0000-000000000007") && 
                        <>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label htmlFor='license' className='form-label'>License or Certification</Label>
                                        <input
                                            type='text'
                                            className='form-control border-primary-subtle'
                                            id='license'
                                            name='license'
                                            placeholder='License or Certification Number'
                                            {...register("license",{required:"License or Certificate required",
                                                minLength:{value:5, message:"License or Certification Number must have atleast 6 characters"},
                                                maxLength:{value:15,message:"License or Certification Number must have maximun 15 characters"}
                                            })}
                                        />
                                        {errors.license && <span className="text-danger">{errors.license.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label htmlFor='expirationdate' className='form-label'>License End Date</Label>
                                        <input
                                            type='date'
                                            className='form-control border-primary-subtle'
                                            id='expirationdate'
                                            name='expirationdate'
                                            min={new Date().toISOString().split("T")[0]}
                                            {...register("expirationdate",{required:"Expiration Date of License or Certification is required",
                                                validate: (value) => {
                                                    const today = new Date().toISOString().split("T")[0];
                                                    return value >= today || "Previous dates are not allowed"
                                                }
                                            })}
                                        />
                                        {errors.expirationdate && <span className="text-danger">{errors.expirationdate.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label htmlFor='appraisersignature' className='form-label'>Appraiser Signature</Label>
                                        <input
                                            type='file'
                                            className='form-control border-primary-subtle'
                                            id='appraisersignature'
                                            name='appraisersignature'
                                            accept='.pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg'
                                            {...register("appraisersignature",{required: isEditMode ? false : "Appraiser signature is required. Please upload a valid file.",
                                                validate:{
                                                    isAllowedType: (files)=>{
                                                        if(!files || files.length === 0) return true;
                                                        for(let file of files){
                                                            if(!["application/pdf", "image/png", "image/jpeg"].includes(file.type)){
                                                                return "File type not supported - upload a PDF, PNG, or JPEG"
                                                            }
                                                        }
                                                        return true;
                                                    }
                                                }
                                            })}
                                        />
                                        {errors.appraisersignature && <span className="text-danger" style={{fontSize:"13px"}}>{errors.appraisersignature.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label htmlFor='appraisercertificate' className='form-label'>Appraisal Certificate</Label>
                                        <input
                                            type='file'
                                            className='form-control border-primary-subtle'
                                            id='appraisercertificate'
                                            name='appraisercertificate'
                                            accept='i.pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg'
                                            {...register("appraisercertificate",{required: isEditMode ? false : "Appraiser certificate is required. Please upload a valid file.",
                                                validate:{
                                                    isAllowedType: (files)=>{
                                                        if(!files || files.length === 0) return true;
                                                        for(let file of files){
                                                            if(!["application/pdf", "image/png", "image/jpeg"].includes(file.type)){
                                                                return "File type not supported - upload a PDF, PNG, or JPEG"
                                                            }
                                                        }
                                                        return true;
                                                    }
                                                }
                                            })}
                                        />
                                        {errors.appraisercertificate && <span className="text-danger" style={{fontSize:"13px"}}>{errors.appraisercertificate.message}</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                        </>
                    }

                    <div style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
                        <Button type='submit' className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }} disabled={isPending || isEditing}>
                            {isPending || isEditing ? <Spinner size='sm'/> : 'Submit'}
                        </Button>
                    </div>
                </Form>
            </Col>
        </Row>
    </Container>
  )
}

export default AddEditForm